var React = require('react');

function Placeholder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 1v22H1V1h22m1-1H0v24h24V0z","key":0}),React.createElement("path",{"d":"M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z","key":1})]);
}

Placeholder.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Placeholder;

Placeholder.default = Placeholder;
